import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import moment from 'moment';

// material
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  TableHead,
  CircularProgress,
  Icon,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Dialog,
  Divider,
  Avatar,
  IconButton,
} from '@mui/material';
import { Box } from '@mui/system';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// components
import { EditRounded, RemoveRedEyeRounded } from '@mui/icons-material';
import axios from 'axios';
import UserPopup from '../components/UserPopup';
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import Popup from '../components/PopUp';
// mock
import Filter from '../components/filters/ClientFilter';
import Iconify from '../components/Iconify';

import { commonHeadStyle, commonBodyStyle } from '../theme/commonStyles';
import BreadCrumps from '../components/BreadCrumps';
// import AddWorkReport from '../components/AddWorkReport';

// import { FilterForm } from '../components/FilterForm';

// ----------------------------------------------------------------------

// const customToolBar = ({setFilter})
export default function WorkReport() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const  projectId  = searchParams.get('projectId');
  const [userData, setUserData] = useState();
  const [pages, setPages] = useState(0);
  const [userCount, setUserCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10); 
  const [isLoading, setIsLoading] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState();
  const size = 10;
  const [options, setOptions] = useState({ size, page: 0, projectId });
  const [input, setInput] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [editUserPopup, setEditUserPopup] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [workreportStatuses, setWorkReportStatuses] = useState([]);

  const getWorkReports = (options) => {
    console.log(options);
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/workreport/admin/all`, {
        params: options,
      })
      .then((res) => {
        console.log('ressssssssssss', res);
        if (res.data.isError === false) {
          setUserCount(res.data.data.maxRecord);
          setUserData(res.data.data.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const handleStatusChange = (event, item, index) => {
    console.log('item', item);
    if (`${item.isactive}` === event.target.value) {
      return;
    }
    setSelectedIndex(index);
  };

  const handworkreportdModal = () => {
    setOpenModal(!openModal);
  };

  const handleEditModal = () => {
    setEditUserPopup(!editUserPopup);
  };

  const handleClose = (refresh = false, message = '') => {
    setSelectedIndex();
    console.log(refresh);
    if (refresh) {
      getWorkReports(options);
    }
    if (message) {
      toast(message);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPages(newPage);
    const temp = { ...options, page: newPage };
    setOptions(temp);
    getWorkReports(temp);
  };

  const applyFilters = (filter) => {
    console.log('filter', filter);
    const temp = { page: 0, size };
    if (filter.userId.length) {
      temp.userId = filter.userId;
    }
    if (filter.name.trim()) {
      temp.name = filter.name.trim();
    }
    if (filter.email.length) {
      temp.email = filter.email;
    }
    if (filter.startDate.length) {
      temp.startDate = filter.startDate;
    }
    if (filter.endDate.length) {
      temp.endDate = filter.endDate;
    }
    if (filter.role.length) {
      temp.role = filter.role;
    }
    if (filter.isBlocked) {
      temp.isBlocked = filter.isBlocked;
    }
    setOptions(temp);
    setPages(0);
    getWorkReports(temp);
  };

  const goToPage = () => {
    if (input > Math.ceil(userCount / size)) {
      return;
    }
    setInput(input > 0 ? input : 1);
    setPages(input - 1 >= 0 ? input - 1 : 0);
    const temp = { ...options, page: input - 1 };
    setOptions(temp);
    getWorkReports(temp);
  };

  useEffect(() => {
    getWorkReports(options);
  }, []);

  const minutesToHours = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}h ${mins}m`;
  };

  return (
    <>
      <Page title="Work Reports">
        {isLoading ? (
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '50vh',
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <>
            <ToastContainer />
            <Container maxWidth="xl">
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                <BreadCrumps
                  nonProject={'true'}
                  mainPage="Work Reports"
                  arrayItems={
                    projectId
                      ? [
                          {
                            title: userData[0]?.project?.name,
                            path: `/dashboard/project/projects/${projectId}`,
                          },
                        ]
                      : []
                  }
                />

                {/* <Dialog open={openModal} onClose={handworkreportdModal}>
                  <UserPopup closePopup={handworkreportdModal} title={'Create New WorkReport'}>
                    <AddWorkReport closePopup={handworkreportdModal} getApi={getWorkReports} options={options} />
                  </UserPopup>
                </Dialog> */}

                {/* <Stack direction="row" spacing={1.5}>
                  <Button variant="contained" onClick={handworkreportdModal} color="buttonone">
                    New WorkReport
                  </Button>
                </Stack> */}
              </Stack>
              <Card>
                <Stack direction="row" spacing={2} padding={2} justifyContent={'space-between'}>
                  <Stack direction="row" spacing={1.5}>
                    <TextField
                      size="small"
                      style={{ maxWidth: '100px' }}
                      type="number"
                      component="div"
                      label="Go to"
                      value={input}
                      onInput={(e) => setInput(e.target.value)}
                    />
                    <Button
                      variant="contained"
                      onClick={goToPage}
                      sx={{
                        backgroundColor: '#0096DB',
                        height: '40px',
                      }}
                    >
                      Go
                    </Button>
                  </Stack>
                  <Button
                    color="buttonone"
                    variant="contained"
                    onClick={() => setFilterOpen(!filterOpen)}
                    startIcon={<Iconify icon="ic:round-filter-list" />}
                  >
                    Filter
                  </Button>
                </Stack>
                <Filter applyFilters={applyFilters} open={filterOpen} setOpen={setFilterOpen} filterValues={options} />
                <Divider
                  sx={{
                    background: ' rgba(0, 0, 0, 0.50)',
                    marginBottom: '24px',
                  }}
                />
                <Scrollbar>
                  <TableContainer sx={{ minWidth: 800 }}>
                    <Table>
                      {/* <UserListHead /> */}
                      <TableHead>
                        <TableRow>
                          <TableCell sx={commonHeadStyle}>Sl No</TableCell>
                          <TableCell sx={commonHeadStyle}>Date</TableCell>
                          <TableCell sx={commonHeadStyle}>Employee</TableCell>
                          <TableCell sx={commonHeadStyle}>Project</TableCell>
                          <TableCell sx={commonHeadStyle}>Start Time</TableCell>
                          <TableCell sx={commonHeadStyle}>End Time</TableCell>
                          <TableCell sx={commonHeadStyle}>Hours Worked</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {userData?.map((item, id) => (
                          <TableRow key={id}>
                            <TableCell sx={{ ...commonBodyStyle, width: '60px' }}>{pages * size + (id + 1)}</TableCell>
                            <TableCell sx={{ ...commonBodyStyle }}>
                              {moment.utc(item.date).format('DD-MM-YYYY')}
                            </TableCell>
                            <TableCell sx={{ ...commonBodyStyle }}>{item.employee?.fullname}</TableCell>
                            <TableCell sx={{ ...commonBodyStyle }}>{item.project?.name}</TableCell>
                            <TableCell sx={{ ...commonBodyStyle }}>
                              {moment.utc(item.startTime).format(' DD-MM-YYYY hh:mm A')}
                            </TableCell>
                            <TableCell sx={{ ...commonBodyStyle }}>
                              {moment.utc(item.endTime).format(' DD-MM-YYYY hh:mm A')}
                            </TableCell>
                            <TableCell sx={{ ...commonBodyStyle }}>{minutesToHours(item.minutesWorked)}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Scrollbar>
                <TablePagination
                  rowsPerPageOptions={[]}
                  component={'div'}
                  count={userCount}
                  onPageChange={handlePageChange}
                  rowsPerPage={rowsPerPage}
                  page={pages}
                  showFirstButton
                  showLastButton
                />
              </Card>
            </Container>
          </>
        )}
      </Page>
    </>
  );
}
